export const titleCase = (str : any) => {
    let arr = str.split(" ");
    let result = arr.map(
        function(val: any){
            return val.replace(val.charAt(0), val.charAt(0).toUpperCase())
        }
    )
    return result.join(" ");
}